// extracted by mini-css-extract-plugin
export default {"checkout__product-cart-column":"Checkout_checkout__product-cart-column__QDD-x"};